import { CheckUrlDetailsResponse } from './types';
import { STRICT_URL_REGEXP } from './consts';

const KNOWN_URL_DOMAINS = new Set(
  'place,camera,info,name,academy,aero,arpa,coop,media,museum,mobi,travel,xxx,asia,biz,com,net,org,gov,mil,edu,int,tel,ac,ad,ae,af,ag,ai,al,am,an,ao,aq,ar,as,at,au,aw,ax,az,ba,bb,bd,be,bf,bg,bh,bi,bj,bm,bn,bo,br,bs,bt,bv,bw,by,bz,ca,cc,cd,cf,cg,ch,ci,ck,cl,cm,cn,co,cr,cu,cv,cx,cy,cz,de,dj,dk,dm,do,dz,ec,ee,eg,eh,er,es,et,eu,fi,fj,fk,fm,fo,fr,ga,gd,ge,gf,gg,gh,gi,gl,gm,gn,gp,gq,gr,gs,gt,gu,gw,gy,hk,hm,hn,hr,ht,hu,id,ie,il,im,in,io,iq,ir,is,it,je,jm,jo,jp,ke,kg,kh,ki,km,kn,kp,kr,kw,ky,kz,la,lb,lc,li,lk,lr,ls,lt,lu,lv,ly,ma,mc,md,me,mg,mh,mk,ml,mm,mn,mo,mp,mq,mr,ms,mt,mu,mv,mw,mx,my,mz,na,nc,ne,nf,ng,ni,nl,no,np,nr,nu,nz,om,pa,pe,pf,pg,ph,pk,pl,pm,pn,pr,ps,pt,pw,py,qa,re,ro,ru,rs,rw,sa,sb,sc,sd,se,sg,sh,si,sj,sk,sl,sm,sn,so,sr,st,su,sv,sy,sz,tc,td,tf,tg,th,tj,tk,tl,tm,tn,to,tp,tr,tt,tv,tw,tz,ua,ug,uk,um,us,uy,uz,va,vc,ve,vg,vi,vn,vu,wf,ws,ye,yt,yu,za,zm,zw,рф,укр,сайт,онлайн,срб,cat,pro,local'.split(
    ',',
  ),
);

const KNOWN_DOMAIN_MAX_LENGTH = 7; // максимальная длина среди доменов из списка KNOWN_URL_DOMAINS

export function urlRegexpResultChecker(matchArray: RegExpMatchArray): CheckUrlDetailsResponse {
  const [raw, protocol = 'https://', urlWithoutProtocol, host]: Array<string | undefined> = matchArray;

  const topDomain = host && host.includes('.') && host.split('.').pop();

  if (
    topDomain &&
    topDomain.length <= KNOWN_DOMAIN_MAX_LENGTH &&
    KNOWN_URL_DOMAINS.has(topDomain) &&
    !raw.includes('@')
  ) {
    return { valid: true, href: protocol + urlWithoutProtocol };
  }

  return { valid: false };
}

/**
 * Проверяет, является ли переданная строка ссылкой, и нормализует ее формат для вставки в тег ссылки
 */
export function checkUrl(url: string): CheckUrlDetailsResponse {
  return urlRegexpResultChecker(Array.from(url.matchAll(STRICT_URL_REGEXP))[0] || []);
}
